
  import { mapState, mapGetters } from 'vuex'
  import cms from '~/mixins/common/cms'
  export default {
    name: 'Theme3MobileFooter',
    mixins: [cms],
    data() {
      return {}
    },
    computed: {
      ...mapState({
        isLogin: state => state.settings.isLogin,
        footerCmsLoading: state => state.cms.footerCmsLoading
      }),
      ...mapGetters({
        mobileGameWheelIcon: 'cms/mobileGameWheelIcon'
      }),
      currentRoute() {
        return this.$route.path
      }
    },
    methods: {
      isActive(route) {
        return this.currentRoute === route
      },
      clickCenterMenu() {
        this.$router.push('/')
      }
    }
  }
